import React from 'react';
import { ScorecardProsCons } from './ScorecardProsCons';
import { Scorecard } from '../../../../../entities/applicant_tracking/Scorecard';
import { ScorecardScore } from './ScorecardScore';
import { User } from '../../../../../entities/User';
import { ScorecardCategories } from './ScorecardCategories';
import { IconSpan } from '../../../../../components/IconSpan';

interface PropTypes {
  user: User;
  scorecard: Scorecard;
  prefilledAttributesCount?: number;
  aiScorecardFill: boolean;
  prosConsAlternativeEnabled: boolean;
  setScorecard: (
    value: Scorecard | ((prevScorecard: Scorecard) => Scorecard),
  ) => void;
}

function getProsTitle(prosConsAlternativeEnabled: boolean): string {
  if (!prosConsAlternativeEnabled) return 'Pros';

  return 'Background Experience';
}

function getProsLabel(prosConsAlternativeEnabled: boolean): string {
  if (!prosConsAlternativeEnabled) return "Insert candidate's strengths";

  return "Insert candidate's background experience";
}

function getConsTitle(prosConsAlternativeEnabled: boolean): string {
  if (!prosConsAlternativeEnabled) return 'Cons';

  return 'Motivation';
}

function getConsLabel(prosConsAlternativeEnabled: boolean): string {
  if (!prosConsAlternativeEnabled) return "Insert candidate's weaknesses";

  return "Insert candidate's motivation";
}

export function ScorecardBody(props: PropTypes) {
  const allowedToEdit = props.user.id === props.scorecard.user.id;
  const updateScorecard = (key: 'pros' | 'cons', value: string) => {
    props.setScorecard((prevScorecard) => ({ ...prevScorecard, [key]: value }));
  };

  return (
    <>
      <div className='d-flex justify-content-between'>
        <h2>Scorecard</h2>
        {props.prefilledAttributesCount > 0 && (
          <IconSpan
            className='fs-6 text-dark-500'
            icon={{ name: 'bi-info-circle' }}
            spanText='All pre-filled attributes were rated during the interview'
          />
        )}
      </div>
      <ScorecardCategories {...props} className='my-3' />
      <ScorecardProsCons
        title={<h3>{getProsTitle(props.prosConsAlternativeEnabled)}</h3>}
        label={getProsLabel(props.prosConsAlternativeEnabled)}
        value={props.scorecard.pros}
        aiScorecardFill={props.aiScorecardFill && allowedToEdit}
        scorecardId={props.scorecard.id}
        scorecardAttribute={getProsTitle(props.prosConsAlternativeEnabled)}
        setValue={(pros: string) => updateScorecard('pros', pros)}
      />
      <ScorecardProsCons
        title={<h3>{getConsTitle(props.prosConsAlternativeEnabled)}</h3>}
        label={getConsLabel(props.prosConsAlternativeEnabled)}
        value={props.scorecard.cons}
        aiScorecardFill={props.aiScorecardFill && allowedToEdit}
        scorecardId={props.scorecard.id}
        scorecardAttribute={getConsTitle(props.prosConsAlternativeEnabled)}
        setValue={(cons: string) => updateScorecard('cons', cons)}
      />
      <ScorecardScore
        rating={props.scorecard.score}
        setRating={(score: string) =>
          props.setScorecard({ ...props.scorecard, score })
        }
      />
    </>
  );
}
